import { Query } from '@varo/graphql-schema-types';
import GetNearByOffers from 'services/graphql/queries/rewards/GetNearByOffers';
import { RequestPolicy, useQuery } from 'urql';

interface NearByOffersVariables {
  categoryId: string;
  latitude?: number;
  longitude?: number;
  pause?: boolean;
}

const useNearByOffers = ({
  pause,
  categoryId,
  latitude,
  longitude,
}: NearByOffersVariables) => {
  const shouldPauseQuery =
    pause ||
    typeof latitude !== 'number' ||
    typeof longitude !== 'number' ||
    !Number.isFinite(latitude) ||
    !Number.isFinite(longitude);

  const variables = {
    categoryId,
    latitude: latitude ?? 0,
    longitude: longitude ?? 0,
  };

  const [result, reFetchOffers] = useQuery<Query>({
    query: GetNearByOffers,
    variables,
    requestPolicy: 'network-only',
    pause: shouldPauseQuery,
  });

  const { data, fetching: loading, error } = result;

  const reload = (
    { requestPolicy }: { requestPolicy?: RequestPolicy } = {
      requestPolicy: 'network-only',
    },
  ): void => {
    reFetchOffers({ requestPolicy });
  };

  return {
    offers: data?.categoryPage?.categoryView,
    loading,
    error,
    reload,
  };
};
export default useNearByOffers;
